import PromotionScope from './Condition';

export default PromotionScope;
